import { render, staticRenderFns } from "./Orcamentos.vue?vue&type=template&id=edd3b35e&scoped=true&"
import script from "./Orcamentos.vue?vue&type=script&lang=js&"
export * from "./Orcamentos.vue?vue&type=script&lang=js&"
import style0 from "./Orcamentos.vue?vue&type=style&index=0&id=edd3b35e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd3b35e",
  null
  
)

export default component.exports